import React from 'react'
import { Link } from 'gatsby'
import {
  Button,
  AnimationWrapper,
} from '..'
import { Parallax } from 'react-scroll-parallax'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import system10 from '../../../assets/system10.svg'
import sqlRocketAnimation from '../../lottie-animations/sql-rocket.json'
import futuriceFamily from '../../../assets/futurice-family.svg'
import * as styles from './styles'
import variables from '../../styles/variables'

const propTypes = {
  content: PropTypes.object.isRequired
}

const Landing = (props) => {
  const { content } = props
  return (
    <styles.IntroContainer>
      <styles.IntroSection>
        <Row>
          <Col xs={12} sm={6}>
            <styles.IntroHeader>
              { content.header }
              <br />
              <span className="nowrap">{ content.headerNoWrapPart }</span>
            </styles.IntroHeader>
            <styles.IntroTagline>
              { content.tagline }
            </styles.IntroTagline>

            <styles.IntroTagline>
              { content.footerTagline }
            </styles.IntroTagline>

            <styles.ButtonContainer>
              <Link to="/request-trial/">
                <Button size="medium">
                  {content.headerButtonText}
                </Button>
              </Link>

              <a href="https://calendly.com/aito-demo">
                <Button
                  size="medium"
                  type="outline"
                  textColor={variables.colors.primary}
                  buttonColor={variables.colors.primary}
                >
                  {content.headerButton2Text}
                  <styles.LinkExternalIcon />
                </Button>
              </a>
            </styles.ButtonContainer>
          </Col>

          <Col xs={12} sm={6}>
            <styles.IntroSectionAnimationCenterer>
              <styles.IntroSectionAnimationContainer>
                <AnimationWrapper animation={sqlRocketAnimation} pauseAt={1.68} />
              </styles.IntroSectionAnimationContainer>
            </styles.IntroSectionAnimationCenterer>
          </Col>
        </Row>

        <styles.LogoContainer>
          <a href="https://futurice.com" target="_blank" rel="noopener noreferrer"><img src={futuriceFamily} alt="a company by Futurice" /></a>
        </styles.LogoContainer>
      </styles.IntroSection>

      <Parallax y={['-30px', '30px']}>
        <styles.IntroSectionSideSquare src={system10} alt="" />
      </Parallax>
    </styles.IntroContainer>
  )
}

Landing.propTypes = propTypes

export default Landing
